module.exports = __webpack_public_path__ + "media/images/badges/bft/milestone-50-inactive-bft-01746d1e3a7b060965d22f5e98e99543.png";